import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  SendSMSRequestByToken,
  SendSMSResponse,
} from "../../models/Communication.model";

const API_URL = environment.apiUrl;

export const sendSMSByToken = createAsyncThunk<
  SendSMSResponse,
  SendSMSRequestByToken,
  { rejectValue: string }
>("sms/sendSMSByToken", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}SMS/SendSMS`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}`);
    }

    const data: SendSMSResponse = await response.json();
    if (!data.success) {
      return rejectWithValue(data.message || "Failed to send SMS");
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});
